import helper from 'store/helper';
import { DASHBOARD } from '../../services/routes/constants';
import { TAB_AD } from './constant';
import types from './types';
import {
  getPageByPath,
  getModeByPath,
} from '../../services/routes/page-helpers';

/**
 * Get The current screen id from url path on initial load.
 * Default to dashboard if path not found.
 * This prevents unnecessary initial page change events from occurring.
 * @type {{tab: string, page: (*|string)}}
 */
export const initialState = {
  tab: TAB_AD,
  mode: getModeByPath(window.location.pathname),
  page: getPageByPath(window.location.pathname)?.screenId ?? DASHBOARD,
};

const changeTab = (state, action) => {
  const { tab } = action.payload;
  return {
    ...state,
    tab,
  };
};

const changeMode = (state, action) => {
  const { mode } = action.payload;
  return {
    ...state,
    mode,
  };
};

const changePage = (state, action) => {
  const { page } = action.payload;
  return {
    ...state,
    page,
  };
};

const SettingsReducer = helper.createReducer(initialState, {
  [types.CHANGE_TAB]: changeTab,
  [types.CHANGE_MODE]: changeMode,
  [types.CHANGE_PAGE]: changePage,
});

export default SettingsReducer;
